module.exports = __webpack_public_path__ + "static/img/img_bg_tree.b5b5c5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/couponsys/assets/images/savethetrees/img_bg_tree.png
// module id = Wqit
// module chunks = 0